import React, { useEffect } from "react"

import * as styles from "./menu.module.css"
import { testIds } from "../../common/constants"

import Link from "../link"
import MainNavigation from "../menu/main-navigation"

const blockBodyScroll = (block = true) => {
  const scrollRoot = document.documentElement
  if (block) {
    scrollRoot.classList.add("menu--open")
  } else {
    scrollRoot.classList.remove("menu--open")
  }
}

const Menu = ({ config, active, toggleMenu }) => {
  useEffect(() => {
    blockBodyScroll(active)
    return () => blockBodyScroll(false)
  }, [active])

  // when the menu is closed, menu links should not be reachable via the TAB key
  const linkTabIndex = active ? 0 : -1

  return (
    <div
      className={`${styles.wrapper} ${active ? styles.activeWrapper : ""}`}
      tabIndex={-1}
      data-test-id={testIds.global.header.navigation.menu.container}
    >
      <MainNavigation
        className={styles.navigation}
        linkClassName={styles.link}
        activeLinkClassName={styles.activeLink}
        pages={config.pages}
        onClickPage={toggleMenu}
        tabIndex={linkTabIndex}
      />

      <nav className={styles.navigation}>
        {config.socialMediaChannels.map(channel => (
          <Link
            key={channel.id}
            className={`${styles.link} ${styles.socialLink}`}
            to={channel.url}
            tabIndex={linkTabIndex}
          >
            {channel.title}
          </Link>
        ))}
      </nav>
    </div>
  )
}

export default Menu
